<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                    <div class="d-flex flex-wrap flex-column flex-sm-row-reverse flex-grow-1 justify-space-between ga-3">
                        <div class="flex-grow-more flex-grow-md-1 d-flex align-center ga-3">
                            <div class="d-flex flex-grow-1 min-w-0">
                                <div class="w-100 min-w-12rem w-md-20rem max-w-100">
                                    <v-text-field
                                        v-model="datatable.request.search.value"
                                        :label="tableCard.searchInput.label"
                                        :placeholder="tableCard.searchInput.placeholder"
                                        :density="tableCard.searchInput.density"
                                        :flat="tableCard.searchInput.flat"
                                        :variant="tableCard.searchInput.variant"
                                        :single-line="tableCard.searchInput.singleLine"
                                        :hide-details="true"
                                        @update:model-value="() => datatable.onSearch()"
                                        clearable
                                        :class="[`table-action`, tableCard.searchInput.class]"
                                    >
                                    <template #prepend-inner >
                                        <span >
                                            <mdi-icon>search</mdi-icon>
                                        </span>
                                    </template>
                                    </v-text-field>
                                </div>
                            </div>
                            <div class="d-flex justify-end ga-2 ga-md-3">
                                <div class="dt-filter-open-btn">
                                    <div class="d-none d-sm-block">
                                        <v-btn-icon text="" class="match-input-compact table-action" color="primary">
                                            <mdi-icon>filter_alt</mdi-icon>
                                            
                                        </v-btn-icon>
                                    </div>
                                    <div class="d-sm-none">
                                        <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                            <mdi-icon :size="tableCard.actionMenu.btn.iconSize">filter_alt</mdi-icon>
                                        </v-btn-icon>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-none d-sm-block">
                                        <v-btn-input-compact text="" class="table-action" color="warning" @click.prevent="confirmArchiveBulk">
                                            <mdi-icon>archive</mdi-icon> Archive
                                        </v-btn-input-compact>
                                    </div>
                                    <div class="d-sm-none">
                                        <v-btn-icon :color="tableCard.actionMenu.btn.color" class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant" @click.prevent="confirmArchiveBulk">
                                            <mdi-icon :size="tableCard.actionMenu.btn.iconSize">archive</mdi-icon>
                                        </v-btn-icon>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-none d-sm-block">
                                        <v-btn-input-compact text="" class="table-action" color="success" @click.prevent="confirmSettlementBulk">
                                            <mdi-icon>verified</mdi-icon> Settle
                                            
                                        </v-btn-input-compact>
                                    </div>
                                    <div class="d-sm-none">
                                        <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant" @click.prevent="confirmSettlementBulk">
                                            <mdi-icon :size="tableCard.actionMenu.btn.iconSize">verified</mdi-icon>
                                        </v-btn-icon>
                                    </div>
                                </div>
                                
                                <v-menu activator=".dt-filter-open-btn" v-model="filterFormOpen" :close-on-content-click="false">
                                    <v-sheet color="surface" class="pa-4 max-w-100 w-30rem">
                                        <form @submit.prevent="filter" class="d-flex flex-column ga-4">
                                            <div>
                                                <v-select-v1
                                                    clearable
                                                    label="Status"
                                                    v-model="filterForm.status"
                                                    :items="Object.values(page.props.data.statuses ?? {})"
                                                    item-title="name"
                                                    item-value="key"
                                                    density="compact"
                                                >
                                                    <template v-slot:item="{ props, item }">
                                                        <v-list-item v-bind="props" :title="null">
                                                            <div class="fs-n1">{{ item.raw.name }}</div>
                                                        </v-list-item>
                                                    </template>
                                                </v-select-v1>
                                            </div>
                                            <div>
                                                <v-select-v1
                                                    label="Archive"
                                                    v-model="filterForm.archive_scope"
                                                    :items="page.props.data.archiveScopes ?? []"
                                                    item-title="name"
                                                    item-value="key"
                                                    density="compact"
                                                ></v-select-v1>
                                            </div>
                                            <div>
                                                <v-autocomplete-v1
                                                    clearable
                                                    label="Admin"
                                                    v-model="filterForm.user_id"
                                                    :items="page.props.data.admins ?? []"
                                                    item-title="name"
                                                    item-value="id"
                                                    density="compact"
                                                >
                                                    <template v-slot:item="{ props, item }">
                                                        <v-list-item v-bind="props" :title="null">
                                                            <div class="fs-n1">{{ item.raw.name }} ({{ item.raw.email }})</div>
                                                        </v-list-item>
                                                    </template>
                                                </v-autocomplete-v1>
                                            </div>
                                            <div class="d-flex justify-end ga-2">
                                                <v-btn type="button" color="btn-secondary" :disabled="filterForm.processing" @click.prevent="clearFilterForm">
                                                    clear
                                                </v-btn>
                                                <v-btn type="submit" :loading="filterForm.processing" :disabled="filterForm.processing">
                                                    Apply
                                                </v-btn>
                                            </div>
                                        </form>
                                    </v-sheet>
                                </v-menu>
                            </div>
                        </div>
                        <div class="flex-grow-1 flex-grow-md-more">
                            <div class="d-flex ga-3 gy-1 flex-wrap">
                                <div class="flex-grow-1 flex-grow-sm-0">
                                    <v-alert color="primary-lightest" border="start" class="py-2">
                                        <div>
                                            Confirmed Paid: <span class="fw-medium">{{ helpers.moneyFormatNew(datatable.additionalData.value?.total_confirmed_paid, 0, false) }}</span>
                                        </div>
                                        <div>
                                            Payable: <span class="fw-medium">${{ helpers.moneyFormatNew(datatable.additionalData.value?.total_confirmed_paid_amount, 2, false) }}</span>
                                        </div>
                                        <div>
                                            Original: <span class="fw-medium">${{ helpers.moneyFormatNew(datatable.additionalData.value?.total_confirmed_paid_amount_original, 2, false) }}</span>
                                        </div>
                                    </v-alert>
                                </div>
                                <div class="flex-grow-1 flex-grow-sm-0">
                                    <v-alert color="success-lightest" border="start" class="py-2">
                                        <div>
                                            Settled: <span class="fw-medium">{{ helpers.moneyFormatNew(datatable.additionalData.value?.total_settled, 0, false) }}</span>
                                        </div>
                                        <div class="text-no-wrap">
                                            Settled Cleared: <span class="fw-medium">${{ helpers.moneyFormatNew(datatable.additionalData.value?.total_settled_paid_amount, 2, false) }}</span>
                                        </div>
                                        <div class="text-no-wrap">
                                            Original: <span class="fw-medium">${{ helpers.moneyFormatNew(datatable.additionalData.value?.total_settled_paid_amount_original, 2, false) }}</span>
                                        </div>
                                    </v-alert>
                                </div>
                                <div class="flex-grow-1 flex-grow-sm-0" v-if="page.props.data.filter_has_preview">
                                    <v-alert color="bg-secondary" border="start" class="py-2 h-100">
                                        <div class="text-no-wrap" v-if="page.props.data.filter_preview?.status">
                                            Status: <span class="fw-medium">{{ page.props.data.filter_preview?.status }}</span>
                                        </div>
                                        <div class="text-no-wrap" v-if="page.props.data.filter_preview?.user">
                                            Admin: <span class="fw-medium">{{ page.props.data.filter_preview?.user }}</span>
                                        </div>
                                        <div class="text-no-wrap" v-if="page.props.data.filter_preview?.archive_scope">
                                            Archive: <span class="fw-medium">{{ page.props.data.filter_preview?.archive_scope }}</span>
                                        </div>
                                    </v-alert>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                     
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                        <template v-slot:[`item.company`]="{ item }:{item: Invoice}" key="item.company">
                             <div>{{ item.company?.name }}</div>
                             <div class="text-secondary-light font-italic fw-medium fs-n5" v-if="item.is_bluebanc">Bluebanc</div>
                         </template>
                         <template v-slot:[`item.amount`]="{ item }:{item: Invoice}" key="item.amount">
                             <div>{{ helpers.moneyFormatNew(item.amount) }}</div>
                         </template>
                         <template v-slot:[`item.usable_amount`]="{ item }:{item: Invoice}" key="item.usable_amount">
                             <div>{{ helpers.moneyFormatNew(item.usable_amount) }}</div>
                         </template>
                         <template v-slot:[`item.status`]="{ item }:{item: Invoice}" key="item.status">
                             <div :class="`fw-medium text-no-wrap text-${item?.status_preview?.color ?? 'secondary'}`">{{ item?.status_preview?.name ?? 'Not found' }}</div>
                             <div class="text-secondary-light font-italic fw-medium fs-n5" v-if="item.is_archived">Archived</div>
                         </template>
                         <template v-slot:[`item.action`]="{ item }:{item: Invoice}" key="item.action">
                             <div>
                                 <div class="d-none d-md-block">
                                     <div class="d-flex justify-end">
                                         
                                         <v-tooltip text="Confirm Paid" v-if="!item.is_archived && !item.is_partial_settled && !item.is_confirmed_paid && !item.is_settled">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="primary" density="compact" v-bind="props" @click.prevent="confirmMarkAsPaid(item)" >
                                                    <mdi-icon>task_alt</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Settle" v-if="!item.is_archived && ((item.is_confirmed_paid && !item.is_settled) || item.is_partial_settled)">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="success" density="compact" v-bind="props" @click.prevent="confirmSettlement(item)" >
                                                    <mdi-icon>verified</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Download">
                                             <template v-slot:activator="{ props }">
                                                <a :href="route('invoices.superadmin.download', item.id)" v-bind="props" target="new" >
                                                    <v-btn-icon-text color="warning" density="compact" >
                                                        <mdi-icon>download</mdi-icon>
                                                    </v-btn-icon-text>
                                                </a>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Delete" v-if="!item.is_archived">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="danger" density="compact" v-bind="props" @click.prevent="dialogDeleteForm_Confirm(item)" >
                                                    <mdi-icon>delete</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                     </div>
                                 </div>
                                 <div class="d-md-none">
                                     <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                         <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                         <v-menu activator="parent" class="tiny-dropdown">
                                             <v-list min-width="120px" >
                                                <a class="v-list-item-n-link" :href="route('invoices.superadmin.download', item.id)" target="new" >
                                                    <v-list-item title="Download" value="download_invoice">
                                                        <template #prepend>
                                                            <mdi-icon>download</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                                </a>
                                                <v-list-item title="Confirm Paid" value="invoice_mark_as_paid"  v-if="!item.is_archived && !item.is_confirmed_paid && !item.is_settled" @click.prevent="confirmMarkAsPaid(item)">
                                                    <template #prepend>
                                                        <mdi-icon>task_alt</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item title="Settle" value="invoice_settle"  v-if="!item.is_archived && item.is_confirmed_paid && !item.is_settled" @click.prevent="confirmSettlement(item)">
                                                    <template #prepend>
                                                        <mdi-icon>verified</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item title="Delete" value="invoice_delete" v-if="!item.is_archived" @click.prevent="dialogDeleteForm_Confirm(item)">
                                                    <template #prepend>
                                                        <mdi-icon>delete</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                             </v-list>
                                         </v-menu>
                                     </v-btn-icon>
                                 </div>
                             </div>
                             
                         </template>
                     </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>
         <v-dialog v-model="markingAsPaid" width="auto" @afterLeave="markingAsPaid = false" :persistent="true">
            <v-card max-width="100%" width="700">
                <v-card-title>Confirm Paid</v-card-title>
                <v-card-subtitle class="text-wrap">Are you sure you want to confirm this invoice as paid?</v-card-subtitle>
                <v-card-text class="py-4">
                    <div class="pb-5">
                        Company: {{ invoiceBeignMarked?.company?.name }} 
                        <span class="text-secondary-light fw-medium" v-if="invoiceBeignMarked?.is_bluebanc">(Bluebanc)</span>
                    </div>
                    <div>
                        <v-number-input-v1
                            label="Amount"
                            placeholder="0.00"
                            :min="0"
                            v-model="markAsPaidForm.amount"
                            @change="(e: any) => {markAsPaidForm.amount = helpers.numberFormatter(e.target.value)}"
                            :error-messages="markAsPaidForm.errors.amount"
                        >
                            <template #prepend-inner>
                                <mdi-icon>payments</mdi-icon>
                            </template>
                            <template #append-inner>
                                USD
                            </template>
                        </v-number-input-v1>
                        <div class="text-note pt-2">Note: Modifying the amount before submitting will update the invoice with the new amount.</div>
                    </div>
                    
                    <div v-if="formMeowPayment.loaded" >
                        <div class="pt-4">
                            Original Amount: <span class="fw-bold">{{ helpers.moneyFormatNew(invoiceBeignMarked?.amount) }}</span>
                        </div>
                        <div class="pt-4">
                            <v-autocomplete-v1
                                clearable
                                label="Meow Payments"
                                v-model="markAsPaidForm.payments"
                                :items="listMeowPayment ?? []"
                                item-title="search"
                                item-value="transactionId"
                                multiple
                                chips
                                closable-chips
                                @update:model-value="onSelectMeowPayments"
                            >
                                <template v-slot:item="{ props, item }">
                                    <v-list-item v-bind="props" :title="null">
                                        <div class="fs-n1">{{ item.raw.payee }} ({{ helpers.moneyFormatNew(item.raw.amount, 2) }}) ({{ item.raw.date }}) <span class="fw-bold text-warning">{{ item.raw.approved ? '(Approved)' : '' }}</span></div>
                                    </v-list-item>
                                </template>
                                <template v-slot:chip="{ props, item }">
                                    <v-chip
                                        v-bind="props"
                                        :text="`${item.raw.payee} (${helpers.moneyFormatNew(item.raw.amount, 2)})`"
                                    ></v-chip>
                                </template>
                            </v-autocomplete-v1>
                        </div>
                        <div class="text-note pt-2">
                            Search: Company name | Amount | Date (YYYY-MM-DD)
                        </div>
                    </div>

                    <div>
                        <div class="pt-4">
                            <v-btn color="primary" class="text-none" block :loading="formMeowPayment.processing" :disabled="formMeowPayment.processing" @click.prevent="() => loadMeowPayments(true)">
                                Load 
                                <span v-if="invoiceBeignMarked?.is_bluebanc">Bluebanc</span>
                                <span v-else>Company</span>
                                Meow Payments
                            </v-btn>
                        </div>
                        <div class="pt-2">
                            <v-btn color="warning"  class="text-none" block :loading="formMeowPayment.processing" :disabled="formMeowPayment.processing" @click.prevent="() => loadMeowPayments(false)">Load Bank Account Meow Payments</v-btn>
                        </div>
                        
                    </div>
                    <div v-if="formMeowPayment.errors.custom_error" class="text-error pt-4">{{ formMeowPayment.errors.custom_error }}</div>
                    <div v-if="markAsPaidForm.errors.custom_error" class="text-error pt-4">{{ markAsPaidForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="markingAsPaid = false"
                    ></v-btn>
                    <v-btn
                        :disabled="markAsPaidForm.processing"
                        :loading="markAsPaidForm.processing"
                        @click="markAsPaid"
                        color="success"
                        text="Submit"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
         <v-dialog v-model="settling" width="auto" @afterLeave="settling = false">
            <v-card max-width="100%" width="500">
                <v-card-title>Confirm Settlement</v-card-title>
                <v-card-subtitle>Are you sure you want to settle this invoice?</v-card-subtitle>
                <v-card-text class="py-4">
                    <div class="pb-4 fw-medium">
                        Usable Balance: {{ helpers.moneyFormatNew(settleForm.usable_amount, 2, true) }}
                    </div>
                    <div>
                        <v-number-input-v1
                            label="Settle Amount"
                            placeholder="0.00"
                            :min="0"
                            v-model="settleForm.settle_amount"
                            @change="(e: any) => {settleForm.settle_amount = helpers.numberFormatter(e.target.value)}"
                            :error-messages="settleForm.errors.settle_amount"
                        >
                            <template #prepend-inner>
                                <mdi-icon>payments</mdi-icon>
                            </template>
                            <template #append-inner>
                                USD
                            </template>
                        </v-number-input-v1>
                    </div>
                    <div v-if="settleForm.errors.custom_error" class="text-error pt-4">{{ settleForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="No"
                        color="btn-secondary"
                        @click="settling = false"
                    ></v-btn>
                    <v-btn
                        :disabled="settleForm.processing"
                        :loading="settleForm.processing"
                        @click="settle"
                        color="success"
                        text="Yes"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
         <v-dialog v-model="settlingBulk" width="auto" @afterLeave="settlingBulk = false">
            <v-card max-width="100%" width="500">
                <v-card-title>Confirm Settlement</v-card-title>
                <v-card-subtitle>Are you sure you want to settle these invoices?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div class="text-primary fw-medium">{{ settleBulkForm.invoice_ids.length }} {{ helpers.pluralize(settleBulkForm.invoice_ids.length, 'Invoice is', 'Invoices are') }} selected, and they will be fully settled.</div>
                    <div v-if="settleBulkForm.errors.custom_error" class="text-error">{{ settleBulkForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="settlingBulk = false"
                    ></v-btn>
                    <v-btn
                        :disabled="!settleBulkForm.invoice_ids.length || settleBulkForm.processing"
                        :loading="settleBulkForm.processing"
                        @click="settleBulk"
                        color="success"
                        text="Yes"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
        <v-dialog v-model="archivingBulk" width="auto" @afterLeave="archivingBulk = false">
            <v-card max-width="100%" width="560">
                <v-card-title>Settle and Archive Invoices</v-card-title>
                <v-card-subtitle>This removes the invoices from active admin balances and keeps them in the audit archive.</v-card-subtitle>
                <v-card-text class="py-4">
                    <div class="text-warning fw-medium pb-4">
                        {{ archiveBulkForm.invoice_ids.length }}
                        {{ helpers.pluralize(archiveBulkForm.invoice_ids.length, 'invoice is', 'invoices are') }}
                        selected. Every invoice will become settled and permanently non-payable.
                    </div>
                    <v-textarea-v1
                        label="Archive reason"
                        v-model="archiveBulkForm.reason"
                        rows="3"
                        :error-messages="archiveBulkForm.errors.reason"
                    ></v-textarea-v1>
                    <div class="text-note pt-3">
                        Every invoice must already have a uniquely claimed bank receipt. Retrying this submission is safe and will not subtract balances twice.
                    </div>
                    <div v-if="archiveBulkForm.errors.custom_error" class="text-error pt-4">{{ archiveBulkForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn text="Cancel" color="btn-secondary" @click="archivingBulk = false"></v-btn>
                    <v-btn
                        :disabled="!archiveBulkForm.invoice_ids.length || !archiveBulkForm.reason || archiveBulkForm.processing"
                        :loading="archiveBulkForm.processing"
                        @click="archiveBulk"
                        color="warning"
                        text="Settle and Archive"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteForm.show" width="auto" @afterLeave="dialogDeleteForm_Close">
            <v-card max-width="100%" width="500">
                <v-card-title>Delete Invoice</v-card-title>
                <v-card-subtitle>Are you sure you want to delete this Invoice?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="dialogDeleteForm.errors.custom_error" class="text-error">{{ dialogDeleteForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="No"
                        color="btn-secondary"
                        @click="dialogDeleteForm_Close"
                    ></v-btn>
                    <v-btn
                        :disabled="dialogDeleteForm.processing"
                        :loading="dialogDeleteForm.processing"
                        @click="dialogDeleteForm_Submit"
                        color="error"
                        text="Yes"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { Invoice, InvoiceStatus, InvoiceStatus_Preview, InvoiceStatusPreviewMap } from '@/Types/Models/invoice';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import InvoiceDialog from '@/Pages/Invoices/Manage.vue';
    import helpers from '@/Plugins/helpers';
    import { User } from "@/Types/Models/user";
    import { useDisplay } from 'vuetify';
    import axios from '@/Plugins/axios';
    import { XhrError } from '@/Types/xhr-error';

    containerGapForTable();
    type TableAdditionalData = {
        total_confirmed_paid: number;
        total_confirmed_paid_amount: number;
        total_confirmed_paid_amount_original: number;
        total_settled: number;
        total_settled_paid_amount: number;
        total_settled_paid_amount_original: number;
    };
    type PageData = SharedPageProps & {
        data:{
            table?: TableResponse<Invoice, TableAdditionalData>;
            filter:{
                status: InvoiceStatus | null,
                user_id: number | null,
                archive_scope: 'active' | 'archived' | 'all',
            };
            filter_preview: {
                status?: string,
                user?: string,
                archive_scope?: string,
            };
            filter_has_preview: boolean;
            statuses: InvoiceStatusPreviewMap;
            archiveScopes: {key: 'active' | 'archived' | 'all', name: string}[];
            admins: User[];
            settlementToken: string;
            archiveToken: string;

            total_confirmed_paid: number;
            total_confirmed_paid_amount: number;
            total_settled: number;
            total_settled_paid_amount: number;
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Invoices';
    const display = useDisplay();
    const datatable = useDatatable<Invoice, TableAdditionalData>(route('invoices.superadmin.index'), page.props.data.table, {
        ability:{
            selection: true
        },
        additionalFilters:{
            status: page.props.data.filter.status ?? null,
            user_id: page.props.data.filter.user_id ?? null,
            archive_scope: page.props.data.filter.archive_scope ?? 'active',
        }
    });
    console.log(datatable.request.length)

    const tableCard = useTableCard();
    
    type MeowPayment = {
        companyKey: string,
        transactionId: string,
        payee: string,
        amount: number,
        date: string,
        search: string,
        approved: boolean,
    };
    const listMeowPayment = ref<MeowPayment[]>([]);
    const formMeowPayment = useForm<{
        custom_error: string,
        loaded: boolean,
        
    }>({
        custom_error: '',
        loaded: false,
        
    });

    const markAsPaidForm = useForm<{
        custom_error: string,
        amount: number | null,
        payments: string[]
    }>({
        custom_error: '',
        amount: null,
        payments: [],
    });
    const markingAsPaid = ref(false);
    const invoiceBeignMarked = ref<Invoice | null>(null);
    const confirmMarkAsPaid = async (invoice: Invoice) => {
        listMeowPayment.value = [];
        markAsPaidForm.reset();
        markAsPaidForm.clearErrors();
        formMeowPayment.reset();
        formMeowPayment.clearErrors();
        invoiceBeignMarked.value = invoice;
        markAsPaidForm.amount = helpers.numberFormatter(invoice.amount);
        markingAsPaid.value = true;
    };

    const closeMarkAsPaid = () => {
        markingAsPaid.value = false;
    };

    const loadMeowPayments = (onlyCompany: boolean = true) => {
        formMeowPayment.reset();
        formMeowPayment.clearErrors();
        formMeowPayment.processing = true;
        formMeowPayment.loaded = false;
        listMeowPayment.value = [];
        markAsPaidForm.payments = [];
        onSelectMeowPayments();
        axios.get<{
            data:{
                status: boolean,
                message: string,
                data: MeowPayment[],
            }
        }>(route('invoices.superadmin.listMeowPaymentsForCompany', {
            source: onlyCompany ? (invoiceBeignMarked.value?.is_bluebanc ? 'bluebanc' : 'company') : 'bank_account',
            companyId: invoiceBeignMarked.value?.company_id
        })).then(({data}) => {
            let content = data.data;
            if(content.status && content.data.length){
                listMeowPayment.value = content.data;
                onSelectMeowPayments();
            }
            formMeowPayment.loaded = true;
        })
        .catch((reason: XhrError) => {
            console.log('reason', reason)
            formMeowPayment.setError('custom_error', reason.message);
        })
        .finally(() => {
            formMeowPayment.processing = false;
            
        });
    };

    const onSelectMeowPayments = () => {
        let amount = 0;
        if(markAsPaidForm.payments.length){
            let keys: {[k:string]: string} = {};
            for(let item of markAsPaidForm.payments){
                keys[item] = item;
            }
            for(let item of listMeowPayment.value){
                if(keys[item.transactionId]){
                    amount += item.amount;
                }
            }
            markAsPaidForm.amount = helpers.numberFormatter(amount);
        }
        else{
            markAsPaidForm.amount = helpers.numberFormatter(invoiceBeignMarked.value?.amount);
        }
        
    }

    const markAsPaid = () => {
        markAsPaidForm.post(route('invoices.superadmin.confirmPaid', invoiceBeignMarked.value?.id ?? 0), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                markAsPaidForm.reset();
                invoiceBeignMarked.value = null;
                markingAsPaid.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoice confirmed paid successfully');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    

    const settleForm = useForm<{
        custom_error: string,
        idempotency_key: string,
        settle_amount: number | null,
        usable_amount: number | null,
    }>({
        custom_error: '',
        idempotency_key: '',
        settle_amount: null,
        usable_amount: null,
    });
    const settling = ref(false);
    const invoiceBeignSettled = ref<Invoice | null>(null);
    const confirmSettlement = async (invoice: Invoice) => {
        settleForm.reset();
        settleForm.clearErrors();
        invoiceBeignSettled.value = invoice;
        settleForm.usable_amount = helpers.numberFormatter(invoice.usable_amount);
        settleForm.settle_amount = helpers.numberFormatter(invoice.usable_amount);
        settleForm.idempotency_key = page.props.data.settlementToken;
        settling.value = true;
    };

    const settle = () => {
        settleForm.post(route('invoices.superadmin.settle', invoiceBeignSettled.value?.id ?? 0), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                settleForm.reset();
                invoiceBeignSettled.value = null;
                settling.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoice marked as settled successfully');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    const settleBulkForm = useForm<{
        custom_error: string,
        idempotency_key: string,
        invoice_ids: (string | number)[],
        
    }>({
        custom_error: '',
        idempotency_key: '',
        invoice_ids: [],
        
    });
    const settlingBulk = ref(false);
    const confirmSettlementBulk = () => {
        settleBulkForm.reset();
        settleBulkForm.clearErrors();
        if(!datatable.selectedRows.value.length){
            settleBulkForm.setError('custom_error', 'You need to select invoices first');
        }
        settleBulkForm.invoice_ids = datatable.selectedRows.value;
        settleBulkForm.idempotency_key = page.props.data.settlementToken;
        settlingBulk.value = true;
    };

    const settleBulk = () => {
        if(!settleBulkForm.invoice_ids.length){
            settleBulkForm.setError('custom_error', 'You need to select invoices first');
            return;
        }
        settleBulkForm.clearErrors();
        settleBulkForm.post(route('invoices.superadmin.settleBulk'), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                settleBulkForm.reset();
                settleBulkForm.clearErrors();
                datatable.selectedRows.value = [];
                settlingBulk.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoices marked as settled successfully');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    const archiveBulkForm = useForm<{
        custom_error: string,
        idempotency_key: string,
        invoice_ids: (string | number)[],
        reason: string,
    }>({
        custom_error: '',
        idempotency_key: '',
        invoice_ids: [],
        reason: '',
    });
    const archivingBulk = ref(false);
    const confirmArchiveBulk = () => {
        archiveBulkForm.reset();
        archiveBulkForm.clearErrors();
        if(!datatable.selectedRows.value.length){
            archiveBulkForm.setError('custom_error', 'You need to select invoices first');
        }
        archiveBulkForm.invoice_ids = datatable.selectedRows.value;
        archiveBulkForm.idempotency_key = page.props.data.archiveToken;
        archivingBulk.value = true;
    };
    const archiveBulk = () => {
        if(!archiveBulkForm.invoice_ids.length){
            archiveBulkForm.setError('custom_error', 'You need to select invoices first');
            return;
        }
        archiveBulkForm.clearErrors();
        archiveBulkForm.post(route('invoices.superadmin.archiveBulk'), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                archiveBulkForm.reset();
                archiveBulkForm.clearErrors();
                datatable.selectedRows.value = [];
                archivingBulk.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoices settled and archived successfully');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    const dialogDeleteForm = useForm<{
        show: boolean,
        item: Invoice | null,
        custom_error: string,
    }>({
        show: false,
        item: null,
        custom_error: '',
    });
    const dialogDeleteForm_Confirm = (item: Invoice) => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
        dialogDeleteForm.item = item;
        dialogDeleteForm.show = true;
    }
    const dialogDeleteForm_Close = () => {
        dialogDeleteForm.reset();
        dialogDeleteForm.clearErrors();
    }
    const dialogDeleteForm_Submit = () => {
        dialogDeleteForm.transform((data) => ({
            custom_error: data.custom_error
        })).delete(route('invoices.superadmin.delete', dialogDeleteForm.item?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                dialogDeleteForm_Close();
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoice is deleted');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    }

    const filterFormOpen = ref(false);
    
    const filterForm = useForm<{
        status: InvoiceStatus | null,
        user_id: number | null,
        archive_scope: 'active' | 'archived' | 'all',
    }>({
        status: null,
        user_id: null,
        archive_scope: 'active',
    });
    filterForm.status = page.props.data.filter.status ?? null;
    filterForm.user_id = page.props.data.filter.user_id ?? null;
    filterForm.archive_scope = page.props.data.filter.archive_scope ?? 'active';
    const clearFilterForm = () => {
        filterForm.reset();
        filterForm.clearErrors();
        filter();
    }
    const filter = () => {
        datatable.request.additionalFilters.status = filterForm.status;
        datatable.request.additionalFilters.user_id = filterForm.user_id;
        datatable.request.additionalFilters.archive_scope = filterForm.archive_scope;
        datatable.onSearch();
        filterFormOpen.value = false;
    }


    
 </script>
